import * as React from "react";
import { useGetConfigAppQuery } from "../../../utils/api/config/config.api";
import { createMarkup } from "../../../utils/Utils";
import { TextSkeleton } from "../../admin/Parametres/Steps/CguAdmin";
import FooterPage from "../../auth/FooterPage";
import FrontFooter from "../FrontFooter/FrontFooter";
import FrontHeader from "../FrontHeader/FrontHeader";

const CguPage = () => {
  const { data, isLoading } = useGetConfigAppQuery();
  
  return (
    <div className="landing-page-component">
      <FrontHeader />
      <div className="page-content bg-white py-5">
        <div className="container-easy-market">
          <div className="container">
            <div className="container-banner-policy">
              <h2 className="title-banner-policy">Conditions générales de vente</h2>
            </div>
            <div className="container-text-policy pb-5">
              {!!isLoading && <TextSkeleton />}
              {!isLoading && (
                data?.cgu ? (
                  <div
                    className="text-policy"
                    dangerouslySetInnerHTML={createMarkup(data?.cgu)}
                  />
                ) : (
                  <div className="custom-politique-page-content pt-5">
                    <div className="content-all-politique pt-4 pb-3">
                      <div className="content-politique-item">
                        <h3 className="custom-sm-title pb-4">
                          1. Commandes et paiements
                        </h3>
                        <div className="custom-sm-value">
                          <div className="custom-sm-value">
                            <strong>1.1. Passer une commande :</strong> Lorsque vous passez une commande sur notre site, vous acceptez d'acheter les produits ou services sélectionnés aux prix et conditions indiqués.
                          </div>
                          <div className="custom-sm-value pt-2">
                            <strong>1.2. Paiements :</strong> Les paiements sont traités de manière sécurisée via des méthodes de paiement en ligne sécurisées. Les informations de paiement sont cryptées et protégées.
                          </div>
                        </div>
                      </div>

                      <div className="content-politique-item pt-5">
                        <h3 className="custom-sm-title pb-4">
                          2. Limitation de responsabilité
                        </h3>
                        <div className="custom-sm-value">
                          <div className="custom-sm-value">
                            <strong>2.1. Limitation de responsabilité :</strong> Nous déclinons toute responsabilité pour tout dommage direct, indirect, spécial, consécutif ou punitif résultant de l'utilisation de nos produits ou services.
                          </div>
                        </div>
                      </div>

                      <div className="content-politique-item pt-5">
                        <h3 className="custom-sm-title pb-4">
                          3. Modification de nos conditions de vente
                        </h3>
                        <div className="custom-sm-value">
                          <div className="custom-sm-value">
                            <strong>3.1. Modifications :</strong> Nous nous réservons le droit de modifier ces conditions de vente à tout moment. Les modifications seront effectives dès leur publication sur notre site.
                          </div>
                        </div>
                      </div>

                      <div className="content-politique-item pt-5">
                        <h3 className="custom-sm-title pb-4">
                          4. Contact
                        </h3>
                        <div className="custom-sm-value">
                          <div className="custom-sm-value">
                            <strong>4.1. Contact :</strong> Pour toute question concernant nos conditions de vente, veuillez nous contacter.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )
              )}
            </div>
          </div>
          <FooterPage />
        </div>
      </div>
      <FrontFooter />
    </div>
  );
};

export default CguPage;